/** Énumérations partagées — source de vérité : docs/04-data-model.md */
export const MEMBERSHIP_ROLES = ['parent', 'professional'];
export const MEMBERSHIP_STATUSES = ['active', 'invited', 'left'];
/**
 * Les schémas de garde vivent dans `custody/schemas.ts` : ils portent, en plus de leur
 * identifiant, un libellé, une famille et la capacité du moteur à les générer. Les lister
 * une seconde fois ici les ferait diverger.
 */
export const PROPOSAL_TYPES = [
    'schedule_change',
    'day_swap',
    'exception',
    'split_rule_change',
    'expense_dispute',
];
export const PROPOSAL_STATUSES = [
    'pending',
    'accepted',
    'declined',
    'countered',
    'expired',
];
export const EXPENSE_STATUSES = ['declared', 'accepted', 'disputed', 'settled'];
export const ALERT_LEVELS = ['normal', 'urgent'];
/** Liste fermée — garde-fou anti-harcèlement (docs/02-fonctionnel.md §4 bis). */
export const ALERT_REASONS = ['sante', 'securite', 'ecole', 'passage_de_bras'];
/**
 * Fil de messagerie où atterrit une urgence déposée au-delà du quota (docs/02 §4 bis).
 *
 * Au-delà de deux urgences par 24 h, l'alerte ne devient pas une alerte au rabais : elle
 * cesse d'être une alerte. Elle part comme message, dans un fil à part — parce qu'une
 * urgence qui n'en est plus une reste une chose qu'on a voulu dire, et que la noyer dans
 * la conversation générale la ferait passer pour un propos ordinaire.
 *
 * La clé est partagée entre l'API, qui l'écrit, et l'onglet qui la donne à lire : recopiée
 * de part et d'autre, elle finirait par diverger et les messages atterriraient dans un fil
 * que personne n'affiche.
 */
export const FIL_URGENCES = 'urgences';
export const JOURNAL_VISIBILITIES = ['shared', 'private'];
/** Zones de vacances scolaires françaises. */
export const SCHOOL_ZONES = ['A', 'B', 'C'];
//# sourceMappingURL=enums.js.map